import React from 'react';
import { Paper, Box, Skeleton } from '@mui/material';

/** Placeholder de carregamento com o mesmo formato do KpiCard. */
export default function SkeletonCard() {
    return (
        <Paper
            elevation={0}
            aria-hidden="true"
            sx={{ p: { xs: 2, sm: 2.5 }, borderRadius: 2, height: '100%', boxShadow: '0 2px 10px rgba(0,0,0,0.05)' }}
        >
            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
                <Box sx={{ flex: 1 }}>
                    <Skeleton variant="text" width="55%" height={18} />
                    <Skeleton variant="text" width="40%" height={40} />
                    <Skeleton variant="text" width="65%" height={14} />
                </Box>
                <Skeleton variant="circular" width={46} height={46} sx={{ ml: 1, flexShrink: 0 }} />
            </Box>
        </Paper>
    );
}
